// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_3SkUZ8WxRos_-3OJjX3JBo","externalId":"_2MTddFPeqsaq3MCdXEE7gx"};